export default class Header {

  constructor(el) {
    this.el = el
    this.hamburger = el.querySelector('.hamburger')
    this.hamburgerText = el.querySelector('.hamburger-text')
    this.menu = el.querySelector('.header--menu')
    this.nav = el.querySelector('.header--nav')
    this.secondarySections = [...document.querySelectorAll('.colored--secondary')]

    if (!this.hamburger) return

    this.bindHamburger()
    this.bindScroll()
    this.updateNavClasses()
  }

  isMenuOpen() {
    return this.menu?.classList.contains('is-full')
  }

  updateNavClasses() {
    if (this.isMenuOpen()) {
      this.nav.classList.add('is-white')
      this.nav.classList.remove('is-scrolled')
      return
    }

    this.nav.classList.remove('is-white')
    this.nav.classList.toggle('is-scrolled', window.scrollY > 30)

    const navHeight = this.nav.getBoundingClientRect().height
    const onSecondary = this.secondarySections.some(section => {
      const rect = section.getBoundingClientRect()
      return rect.top < navHeight && rect.bottom > 0
    })
    this.nav.classList.toggle('is-on-secondary', onSecondary)
  }

  bindScroll() {
    window.addEventListener('scroll', () => this.updateNavClasses(), { passive: true })
  }

  openMenu() {
    this.menu?.classList.add('is-full')

    this.hamburger.classList.add('is-active')
    if (this.hamburgerText) this.hamburgerText.style.opacity = '0'

    window.lenis?.stop()
    this.updateNavClasses()
  }

  closeMenus() {
    this.menu?.classList.remove('is-full')

    this.hamburger.classList.remove('is-active')
    if (this.hamburgerText) this.hamburgerText.style.opacity = '1'

    window.lenis?.start()
    this.updateNavClasses()
  }

  bindHamburger() {
    this.hamburger.addEventListener('click', () => {
      if (this.isMenuOpen()) {
        this.closeMenus()
      } else {
        this.openMenu()
      }
    })
  }

}
